package org.vreo.devicehub.features.device.presentation.deviceManagement.messages

import org.vreo.devicehub.features.core.domain.device.message.AnprCameraMessage

/**
 * Message list actions. Actions that can be performed by message list screen.
 */
sealed interface MessageListActions {
    class OnClearError : MessageListActions
    data class OnUpdateMessageList(val loadNew: Boolean = true) : MessageListActions
    data class OnMessageClick(val message: AnprCameraMessage) : MessageListActions
}